function noop() {
  // placeholder function for default function params
}

var Functions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    noop: noop
});

export { Functions as F, noop as n };
//# sourceMappingURL=Functions-32eb6d37.js.map
